import { w as withConfigTransport } from "../../../../services/config-transport/withConfigTransport-2705a6a5.mjs";
import { _ as _VaSelectOption } from "./VaSelectOption-996be288.mjs";
const VaSelectOption = withConfigTransport(_VaSelectOption);
export {
  VaSelectOption as V
};
//# sourceMappingURL=index-34a50772.mjs.map
